/* eslint-disable promise/param-names */
import { AUTH_REQUEST, SET_TAPPA, SET_USER_TOKEN, AUTH_OK, AUTH_SOCIAL, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT, AUTH_REGISTRATION, AUTH_COMPLATE_REGISTRATION, COMPLATE_REGISTRATION_SUCCESS, REGISTRATION_SUCCESS, REGISTRATION_ERROR } from '../actions/auth'
import { USER_REQUEST, USER_UPDATE_DATA  } from '../actions/user'
import axios from 'axios'


const state = { token: localStorage.getItem('user-token') || '', status: '', login_error: '', loadingState: '', hasLoadedOnce: false }

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
  loginerror: state => state.login_error,
  loadingState: state => state.loadingState
}

const actions = {
  [AUTH_REQUEST]: ({commit, dispatch}, user) => {
    return new Promise((resolve, reject) => { // The Promise used for router redirect in login
	  commit(AUTH_REQUEST)
      axios({ url: process.env.ROOT_API + 'api/login', data: user, method: 'POST', crossDomain: true, headers: {'Authorization': 'Bearer '+ process.env.AUTH_TOKEN, 'Content-type': 'application/json'} })
        .then(resp => {
          const token = resp.data.userToken
          localStorage.setItem('user-token', token) // store the token in localstorage
          commit(AUTH_SUCCESS, token)
          // you have your token, now log in your user :)
          dispatch(USER_REQUEST, resp.data)
          resolve(resp.data)
        })
      .catch(err => {
        commit(AUTH_ERROR, err.response.data.status)
        localStorage.removeItem('user-token') // if the request fails, remove any possible user token if possible
        reject(err)
      })
    })
  },
  [AUTH_REGISTRATION]: ({commit, dispatch}, user) => {
    return new Promise((resolve, reject) => { // The Promise used for router redirect in login
      commit(AUTH_REGISTRATION)
      axios({
	  	url: process.env.ROOT_API + 'add_new_user.php',
	  	data: user,
	  	method: 'POST',
	  	headers: {'Authorization': 'Bearer '+ process.env.AUTH_TOKEN, 'Content-type': 'application/json'} })
	  .then(resp => {
	  	commit(REGISTRATION_SUCCESS, resp.data)
		resolve(resp.data)
	  })
	  .catch(err => {
	  	commit(REGISTRATION_ERROR)
		reject(err)
	  })
    })
  },
  [AUTH_COMPLATE_REGISTRATION]: ({commit, dispatch}, user) => {
    return new Promise((resolve, reject) => { // The Promise used for router redirect in login
      commit( AUTH_COMPLATE_REGISTRATION )
      axios({
	  	url: process.env.ROOT_API + 'editUser.php',
	  	data: user,
	  	method: 'POST',
	  	headers: {'Authorization': 'Bearer '+ process.env.AUTH_TOKEN, 'Content-type': 'application/json'} })
	  .then(resp => {
	  	commit(COMPLATE_REGISTRATION_SUCCESS, resp.data)
		dispatch(USER_UPDATE_DATA, resp.data)
		resolve(resp.data)
	  })
	  .catch(err => {
	  	commit(REGISTRATION_ERROR)
		reject(err)
	  })
    })
  },
  [AUTH_LOGOUT]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_LOGOUT)
      localStorage.removeItem('user-token')
      resolve()
    })
  },
  [SET_USER_TOKEN]: ({commit, dispatch}, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_USER_TOKEN, token)

      dispatch(USER_REQUEST, token)

      resolve()
    })
  },
   [AUTH_OK]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      resolve()
    })
  },

}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
	state.login_error = false
	state.loadingState = true
  },
  [SET_USER_TOKEN]: (state, token) => {
    state.status = 'success'
    state.token = token
    state.hasLoadedOnce = true
  },
  [AUTH_SOCIAL]: (state) => {
    state.status = 'loading'
	state.login_error = false
	state.loadingState = true
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success'
    state.token = resp
    state.hasLoadedOnce = true
	state.loadingState = false
  },
  [AUTH_ERROR]: (state, error) => {
    state.status = error
	state.login_error = true
    state.hasLoadedOnce = true
	state.loadingState = false
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = ''
	state.status = ''
  },
  [AUTH_REGISTRATION]: (state) => {
    state.status = 'loading'
	state.loadingState = true
  },
  [AUTH_COMPLATE_REGISTRATION]: (state) => {
    state.status = 'loading'
	state.loadingState = true
  },
  [REGISTRATION_SUCCESS]: (state) => {
	state.status = 'success'
	state.loadingState = false
  },
  [COMPLATE_REGISTRATION_SUCCESS]: (state) => {
	state.status = 'success'
	state.loadingState = false
  },
   [REGISTRATION_ERROR]: (state) => {
	state.status = 'error'
	state.loadingState = false
  },

}

export default {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js